//Comentario necesario para codificación en UTF-8, ver Inc6743
(function () {
	var App = angular.module('pphhApp');
	
	App.service("rowDetailActionController", [ "$mdDialog", "$window", RowDetailActionController ]);

	function RowDetailActionController($mdDialog, $window) {
		this.performAction = performAction;
		

		function performAction(scope,row) {
			var id = row.id;			
			$window.location.href =_contextPath + "/crud/" + scope.entity.entityName + "/" + id;
		}
	}

})();